import { render, staticRenderFns } from "./SubTitle3.vue?vue&type=template&id=3ac58e12&scoped=true&"
import script from "./SubTitle3.vue?vue&type=script&lang=js&"
export * from "./SubTitle3.vue?vue&type=script&lang=js&"
import style0 from "./SubTitle3.vue?vue&type=style&index=0&id=3ac58e12&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac58e12",
  null
  
)

export default component.exports